import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { BackButton, EditButton } from "../../../Components/Utils/Buttons";
import { NormalHeading } from "../../../Components/Utils/Heading";
import Dasboard from "../../../Components/Icons/Dasboard";
import NuDate from "../../../Components/Utils/NuDate";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";
import EmployeeDetails from "./Components/EmployeeDetails";
import Remark from "./Components/Remark";
import Requests from "./Components/Requests";
import Documents from "./Components/Documents";
import Payslip from "./Components/Payslip";
import TimeSheet from "./Components/TimeSheet";

function ViewEmployee() {
  const { officeId } = useParams();
  const [active, setActive] = React.useState("details");
  const location = useLocation();
  const data = location.state.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  console.log("data- user", data);

  return (
    <div className=" w-full h-full py-2 px-4 ">
      {/* <div className=""> */}
      <div className="md:flex justify-end w-full">
        {/* <Breadcrumb items={[{name:"Employees",
              link:`/main/${data?.branchId}/employees`
            },
            {name:"View Employess"}
            ]} /> */}
        <div className="flex justify-end gap-2">
          {/* <Link to={`/main/${officeId}/employees/${data?.employeeId}`}/><BackButton/><Link/> */}
          <Link
            to={`/main/${officeId}/employees`}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
          <Link
            to={`/main/${officeId}/employees/edit/${data?.employeeId}`}
            state={{
              data: data,
              from: `/main/${officeId}/employees/view/${data?.employeeId}`,
            }}
          >
            <EditButton height="8" />
          </Link>
        </div>
      </div>
      <div className="w-full mx-auto h-[calc(100vh-145px)] overflow-y-hidden mt-4 lg:flex justify-between items-center">
        <div className=" w-full h-full lg:w-[30%] 2xl:w-[20%] bg-white rounded-lg shadow-lg p-3 overflow-y-auto flex flex-col items-center">
          <div className=" h-40 flex justify-center items-center w-36 border p-1 rounded-lg">
            {data?.imageUrl != null ? (
              <img
                src={data?.imageUrl || ""}
                className=" h-[150px] w-auto rounded-lg"
                alt="#"
              />
            ) : (
              <>NO Image</>
            )}
          </div>
          <div className=" w-full rounded-lg border mt-4">
            <p className="py-3 px-1 text-[13px] font-bold text-gray-900">
              Details :
            </p>
            <ViewValue title="Name :" value={data?.name || "-"} />

           <ViewValue title="Position :" value={data?.position || '-'} />

            <p className="py-3 px-1 text-[13px] font-bold text-gray-900">
              Contact :
            </p>
            <ViewValue title="Email :" value={data?.email || "-"} />
            <ViewValue title="Phone :" value={data?.mobileNo || "-"} />
          </div>
        </div>
        <div className=" w-full h-full lg:w-[69%] 2xl:w-[79%] bg-white rounded-lg shadow-lg p-3">
          <div className="flex items-center gap-1 h-9 ">
            <div className={`border border-b-4 shadow-lg cursor-pointer border-textColor-main px-3 py-1 rounded-t-lg text-[13px] ${active==="details" ? "bg-textColor-main text-white font-medium" : " text-textColor-main font-medium"}`} onClick={()=>setActive("details")}>
              Details
            </div>
            <div className={`border border-b-4 shadow-lg cursor-pointer border-textColor-main px-3 py-1 rounded-t-lg text-[13px] ${active==="time sheet" ?"bg-textColor-main text-white font-medium" : " text-textColor-main font-medium"}`} onClick={()=>setActive("time sheet")}>
              Time Sheet
            </div>
            {/* <div className={`border border-b-4 shadow-lg cursor-pointer border-textColor-main px-3 py-1 rounded-t-lg text-[13px] ${active==="pay slip" ? "bg-textColor-main text-white font-medium" : " text-textColor-main font-medium"}`} onClick={()=>setActive("pay slip")}>
              Pay slip
            </div> */}
            <div className={`border border-b-4 shadow-lg cursor-pointer border-textColor-main px-3 py-1 rounded-t-lg text-[13px] ${active==="documents" ?"bg-textColor-main text-white font-medium" : " text-textColor-main font-medium"}`} onClick={()=>setActive("documents")}>
              Documents
            </div>
            <div className={`border border-b-4 shadow-lg cursor-pointer border-textColor-main px-3 py-1 rounded-t-lg text-[13px] ${active==="requests" ? "bg-textColor-main text-white font-medium" : " text-textColor-main font-medium"}`} onClick={()=>setActive("requests")}>
              Requests
            </div>
            <div className={`border border-b-4 shadow-lg cursor-pointer border-textColor-main px-3 py-1 rounded-t-lg text-[13px] ${active==="remarks" ? "bg-textColor-main text-white font-medium" : " text-textColor-main font-medium"}`} onClick={()=>setActive("remarks")}>
              Remarks
            </div>
          </div>
          <div className="w-full h-[calc(100vh-200px)] overflow-y-auto">
            {
              active === "details" && <EmployeeDetails data={data}/> 
            }
            {
              active == "remarks" && <Remark id={data}/>
            }
            {
              active == "documents" && <Documents id={data}/>
            }
            {
              active == "requests" && <Requests id={data}/>
            }
            {/* {
              active == "pay slip" && <Payslip id={data} />
            } */}
            {
              active == "time sheet" && <TimeSheet id={data} />
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewEmployee;

function ViewValue({ title, value }) {
  return (
    <div className="odd:bg-white even:bg-slate-50 w-full border-b last:border-b-0 px-2">
      <p className="w-full pt-1 text-xs font-medium text-gray-900">{title}</p>
      <p className="w-full line-clamp-4 pb-2 text-xs  text-gray-700">{value}</p>
    </div>
  );
}

{
  /* <NormalHeading title={"Employee Details"} />
<div className='flex'> 
     <div className='w-full  flex '>
        <div className='w-full rounded-[20px]  bg-white py-4  flex  flex-col '>
        <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'> Name</p>
                <p className='w-1/2 py-2 pl-5  text-xs  text-[#606279]'>{data?.name || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Email</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.email || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Phone</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.mobileNo || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>DOB</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{
data?.dob ? (
  <NuDate value={data?.dob} format="DD-MMM-YYYY" />
) : (
  ""
)
}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Gender</p>
                <p className='w-1/2 py-2 pl-5 text-xs text-[#606279]'>
{data?.gender === 'M' ? 'Male' : data?.gender === 'F' ? 'Female' : '-'}
</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Type</p>
                <p className='w-1/2 py-2 pl-5 text-xs text-[#606279]'>
{data?.type === '1' ? 'Own' : data?.type === '2' ? 'Rental' : '-'}
</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Category</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.category || '-'}</p>
              </div>
            
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Position</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.position || '-'}</p>
              </div>
                    
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
<p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Current Project</p>
<p className='w-1/2 py-2 pl-5 text-xs text-[#606279]'>
{Array.isArray(data?.currentProjectName) ? data.currentProjectName.join(", ") : data?.currentProjectName || '-'}
</p>
</div>


              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Emergency Name</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.emergencyName || '-'}</p>
              </div>
               <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Emergency MobileNo</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.emergencyMobileNo || '-'}</p>
              </div> 
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Relationship</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.emergencyRelationship || '-'}</p>
              </div>
              
              
    </div>
</div>
<div className='border-r border-[1px] border-slate-200/60 border-solid'/>


        <div className='w-full  flex  '>
        <div className='w-full rounded-[20px]  bg-white py-4  flex  flex-col '>   
        <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Date of Join</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{
data?.dateOfJoin ? (
  <NuDate value={data?.dateOfJoin} format="DD-MMM-YYYY" />
) : (
  ""
)
}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Date of Relieving</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{
data?.dateOfRelieving ? (
  <NuDate value={data?.dateOfRelieving} format="DD-MMM-YYYY" />
) : (
  ""
)
}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>National Id</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.nationalId || '-'} </p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>National-Id Expiry Date</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{
data?.nationalIdExpiryDate ? (
  <NuDate value={data?.nationalIdExpiryDate} format="DD-MMM-YYYY" />
) : (
  ""
)
}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Passport Number</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.passportNumber || '-'} </p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Passport Expiry Date</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{
data?.passportExpiryDate ? (
  <NuDate value={data?.passportExpiryDate} format="DD-MMM-YYYY" />
) : (
  ""
)
}</p>
              </div>
        <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Street Address Line 1</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.address1 || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Street Address Line 2</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.address2 || '-'}</p>
              </div>
            
             
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>City</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.city || '-'} </p>
              </div>
            
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>State</p>
                <p className='w-1/2 py-2 pl-5  text-xs  text-[#606279]'>{data?.state || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Country</p>
                <p className='w-1/2 py-2  pl-5 text-xs  text-[#606279]'>{data?.country || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Zip Code</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.pincode || '-'} </p>
              </div>     
            
            
             
      </div>
    </div>
  </div> */
}
